import PropTypes from 'prop-types';
import React from 'react';
import TString from './TString';

const TDiv = (props) =>
	<TString {...props} tagName="div" />;

export default TDiv;
